import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTriangleRightMedium"><Path d="M17.166 12L9 18.8594V5.14062L17.166 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
